import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportCertificateModalService {

  private selectedCertificateSubject = new BehaviorSubject<any>(null);
  public selectedCertificate$ = this.selectedCertificateSubject.asObservable();

  private preSelectedVehicleSubject = new BehaviorSubject<any>(null);
  public preSelectedVehicle$ = this.preSelectedVehicleSubject.asObservable();

  constructor() { }

  setSelectedCertificate(certificate: any): void {
    this.selectedCertificateSubject.next(certificate);
  }

  getSelectedCertificate(): any | null {
    return this.selectedCertificateSubject.value;
  }

  clearSelectedCertificate(): void {
    this.selectedCertificateSubject.next(null);
  }

  setPreSelectedVehicle(vehicle: any): void {
    this.preSelectedVehicleSubject.next(vehicle);
  }

  getPreSelectedVehicle(): any | null {
    return this.preSelectedVehicleSubject.value;
  }

  clearPreSelectedVehicle(): void {
    this.preSelectedVehicleSubject.next(null);
  }
}
